import { instance, next } from "./base";

const BASE = "/api/v1/admin/email-campaigns";

export const getCampaigns = async (page = 1) => {
  const { data } = await instance()
    .get(BASE, { params: { page } })
    .catch((e) => next(e));
  return data?.data;
};

export const getCampaign = async (id) => {
  const { data } = await instance()
    .get(`${BASE}/${id}`)
    .catch((e) => next(e));
  return data?.data;
};

export const getAudienceCount = async (audience) => {
  const { data } = await instance()
    .get(`${BASE}/audience-count`, { params: { audience } })
    .catch((e) => next(e));
  return data?.data;
};

export const previewCampaign = async (values) => {
  const { data } = await instance()
    .post(`${BASE}/preview`, values)
    .catch((e) => next(e));
  return data?.data;
};

export const sendTestCampaign = async (values) => {
  const { data } = await instance()
    .post(`${BASE}/test`, values)
    .catch((e) => next(e));
  return data;
};

export const saveCampaign = async ({ id, ...values }) => {
  const req = id
    ? instance().patch(`${BASE}/${id}`, values)
    : instance().post(BASE, values);
  const { data } = await req.catch((e) => next(e));
  return data?.data;
};

export const sendCampaign = async (id) => {
  const { data } = await instance()
    .post(`${BASE}/${id}/send`)
    .catch((e) => next(e));
  return data?.data;
};

export const deleteCampaign = async (id) => {
  const { data } = await instance()
    .delete(`${BASE}/${id}`)
    .catch((e) => next(e));
  return data?.data;
};
